export default __webpack_public_path__ + "SamuelMaarek.9ec5f0d.jpg";